import { Controller, useFormContext } from 'react-hook-form'

import {
  FormControl,
  FormControlButtonGroupSelectProps,
} from '@tribeplatform/react-ui-kit/FormControl'

import { FormFieldProps, Optional } from './typings.js'

export function ButtonGroupSelect({
  name,
  validation,
  value: fieldValue,
  onChange: buttonGroupSelectOnChange,
  ...rest
}: FormFieldProps<
  Optional<FormControlButtonGroupSelectProps, 'value' | 'onChange'>
>) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl.ButtonGroupSelect
          {...rest}
          mode={rest.mode}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          value={fieldValue ?? value}
          onChange={value => {
            onChange(value)
            if (typeof buttonGroupSelectOnChange === 'function') {
              buttonGroupSelectOnChange(value)
            }
          }}
        />
      )}
    />
  )
}
